import { create } from "superstruct"

import { CatalogSearchQuery, SearchQuerySchema } from "./schema"

export function buildSearchQuery(query: string): CatalogSearchQuery {
    return create(query.replaceAll(/\Blgbt\B/g, "friendly"), SearchQuerySchema)
}
